import parent from './wgg.module';

/**
 * @ngdoc object
 * @name wgg.run
 *
 *
 * @description
 * wgg run to ?
 */
export default parent.run(function($rootScope) {
    "ngInject";

});




// WEBPACK FOOTER //
// ./src/wgg/wgg.run.js